import { render, staticRenderFns } from "./template-selection-modal.vue?vue&type=template&id=4edd077f&scoped=true"
import script from "./template-selection-modal.vue?vue&type=script&lang=js"
export * from "./template-selection-modal.vue?vue&type=script&lang=js"
import style0 from "./template-selection-modal.vue?vue&type=style&index=0&id=4edd077f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd077f",
  null
  
)

export default component.exports